import { render, staticRenderFns } from "./ProfileHeader.vue?vue&type=template&id=abcc94cc&scoped=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcc94cc",
  null
  
)

export default component.exports